<script setup lang="ts">
import { I18nKey } from '@/utils/typings';
import { computed } from 'vue';
import DeviceStatusIslandThumb from './DeviceStatusIslandThumb.vue';
import { deviceDetailLocation } from './deviceStatusIslandNav';
import { STATE_INFO } from './deviceStatusIslandState';
import { DeviceStatusIslandUnicheckItem } from './deviceStatusIslandTypes';

const props = defineProps<{
  item: DeviceStatusIslandUnicheckItem;
}>();

const stateInfo = computed(() => STATE_INFO[props.item.state]);
</script>

<template>
  <div class="island-row">
    <div class="island-row__header">
      <span class="island-row__name text-body-2 text-truncate">{{ item.headline }}</span>
      <span class="island-row__state text-body-2">
        <v-icon :color="stateInfo.color" :icon="stateInfo.icon" size="14" />
        {{ $t(stateInfo.labelKey as I18nKey) }}
      </span>
    </div>

    <div class="island-row__status">
      <DeviceStatusIslandThumb
        orientation="landscape"
        :to="deviceDetailLocation(item.id)"
        :name="item.headline"
        :pictureId="item.content.pictureId"
        :serialNumber="item.content.serialNumber"
        :typeNumber="item.content.typeNumber"
        :battery="item.battery"
        showBattery
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.island-row {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 12px 4px;

  &:not(:last-child) {
    border-bottom: 1px solid rgba(var(--v-border-color), var(--v-border-opacity));
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    min-width: 0;
  }

  &__name {
    font-weight: 600;
    min-width: 0;
  }

  &__status {
    display: flex;
    justify-content: center;
  }

  &__state {
    display: inline-flex;
    align-items: center;
    gap: 2px;
    white-space: nowrap;
    font-weight: 600;
  }
}
</style>
